module.exports = __webpack_public_path__ + "img/logo.c3fa8f2b.png";